module.exports = __webpack_public_path__ + "static/media/24UHCHR12.b1ce4f64.jpg";